import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { ClientSeasonDependencyTypes } from '@client/entity/client-season/client-season.dependency-types';
import { ClientSeasonApiService } from '@client/entity/client-season/data/service/client-season.api-service';
import { ClientSeasonApiDataTransformer } from '@client/entity/client-season/data/transformer/client-season.api-data-transformer';
import { ClientSeasonRepository } from '@client/entity/client-season/data/repository/client-season.repository';
import { ClientSeasonService } from '@client/entity/client-season/domain/service/client-season.service';

export const clientSeasonContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options.bind<ClientSeasonApiService>(ClientSeasonDependencyTypes.ClientSeasonApiService).to(ClientSeasonApiService);
  options
    .bind<ClientSeasonApiDataTransformer>(ClientSeasonDependencyTypes.ClientSeasonApiDataTransformer)
    .to(ClientSeasonApiDataTransformer);
  options.bind<ClientSeasonRepository>(ClientSeasonDependencyTypes.ClientSeasonRepository).to(ClientSeasonRepository);
  options.bind<ClientSeasonService>(ClientSeasonDependencyTypes.ClientSeasonService).to(ClientSeasonService);
});
